<template>
  <div class="row">
    <!-- 标题-副标题 -->
    <div class="col-md-12">
      <h4 class="title">{{title}}</h4>
      <p class="category">{{category}}</p>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">{{categorySecond}}</div>
      </div>

      <div class="card-body row">
        <!-- 分页 -->
        <div class="col-sm-8">
          <el-select
            class="select-default"
            style="width: 5.5em"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          &nbsp;
          <div style="display: inline-block">
            <el-select
              class="el-select"
              style="width: 8em"
              v-model="currentsearchType"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in searchType"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div style="display:inline-block">
            <fg-input class="input-sm"
                      placeholder="搜索"
                      v-model="searchQuery"
                      @keyup.enter="getData">
            </fg-input>
          </div>
          <p-button @click="getData">搜索</p-button>
        </div>

        <!--搜索 -->
        <div class="col-sm-4">
          <p-button type="info" plain @click="updateAPI" :disabled="my_disable">
            一键更新
          </p-button>

        </div>


        <!-- 表格 -->
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    @selection-change="handleSelectionChange"
                    style="width: 100%">
            <el-table-column type="selection" v-model="course">
            </el-table-column>
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="220"
              fixed="right"
              class-name="td-actions"
              label="操作">
              <template slot-scope="props">
                <p-button type="danger" size="sm" @click="cractResource(props.$index, props.row)">
                  <i slot="label"></i>重新上传线下签名包
                </p-button>

              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 底部 -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{page}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"

                        :page-count="pagination.page_count">
          </p-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="线下签名包上传" :visible.sync="dialogResourceVisible">
      <div style="margin-bottom:3%">
        <span style="display: inline-block">targetSDK版本号： {{this.dialogData.target_version}}</span>
      </div>
      <el-upload
        class="upload-file"
        ref="upload"
        :action="fileUploadUrl"
        :headers="getToken"
        :limit="1"
        :data="postData"
        :on-success="handleAvatarSuccess"
        :on-progress="handleProgress"
        :on-change="resourceChange"
        :file-list="resoucreList"
        :auto-upload="false">
        <div slot="tip" class="el-upload__tip">上传签名包,签名包必须以".apk"结尾</div>
        <div slot="tip" class="el-upload__tip">请核对签名包对应的targetSDK版本</div>
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器
        </el-button>

      </el-upload>
      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option, Dialog} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Search from 'src/components/UIComponents/Search/Search.vue'
  import {getFetch} from 'src/util/fetch'
  import {Cookie} from 'src/util/cookie'

  import {upLoadFile} from "../../../../util/upload";
  import PButton from "../../../UIComponents/Button";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Dialog)
  export default {
    watch: {
      'pagination.perPage'() {
        this.getData()
      },
      'pagination.currentPage'() {
        this.getData()
      },
    },
    components: {
      PButton,
      PPagination,
      Search,
    },
    computed: {
      queriedData() {
        return this.tableData
      },
      to() {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total() {
        return this.total_count
      },
      page() {
        return `从 ${this.from + 1} 到 ${this.to} 共 ${this.total} 条`
      },

    },
    data() {//定义tabel
      return {
        fileUploadUrl: window.Config.host + '/api/apkup/sypt_upload/',
        getToken: {
          token: '',
        },
        floor: "sypt",
        postData: {},
        multipleTable: [],
        resoucreList: [],
        apklist: [],
        my_disable: false,
        title: '第一事业部线下签名包上传记录',
        category: '',
        categorySecond: '',
        dialogResourceVisible: false,
        dialogData: {
          gid: "",
          targetSdkVersion: "",
          channel_type: ""
        },
        dialogFile: "",
        dialogapkVisible: false,
        pagination: {//分页
          perPage: 30,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          page_count: 0,
          total: 0
        },
        searchQuery: '',//搜索值
        currentsearchType: '游戏id',
        searchType: ['游戏id', '游戏名'],//搜索字段
        tableColumns: [//列表
          {
            prop: 'gameid',
            label: '游戏id',
            minWidth: 100
          },
          {
            prop: 'name',
            label: '游戏名',
            minWidth: 100
          },
          {
            prop: 'alias',
            label: '游戏别名',
            minWidth: 100
          },
          {
            prop: 'tt_id',
            label: '头条APPid',
            minWidth: 100
          },
          {
            prop: 'gdt_id',
            label: '广点通appid',
            minWidth: 100
          },
          {
            prop: 'ks_id',
            label: '快手appid',
            minWidth: 100
          },
          {
            prop: 'uc_id',
            label: 'UCappid',
            minWidth: 100
          },
          {
            prop: 'floor',
            label: '所属平台',
            minWidth: 100
          },
          {
            prop: 'target_version',
            label: 'targetSDK',
            minWidth: 120
          },
          {
            prop: "chanel_type",
            label: "渠道分类",
            minWidth: 100
          },
          {
            prop: 'package_path',
            label: '马甲包地址',
            minWidth: 200
          },
          {
            prop: 'user',
            label: '操作者',
            minWidth: 100
          },
          {
            prop: 'upload_time',
            label: '上传时间',
            minWidth: 120
          },
        ],
        tableData: [],//渲染table数据

        //获取游戏信息批量传输给后台
        course: [],
        total_count: 0,

      }
    },
    methods: {
      handleSelectionChange(val) {
        this.multipleTable = val;               //  this.multipleTable 选中的值
        // console.log(val);
      },
      async updateAPI() {
        this.updateIds = []
        for (var i = 0; i < this.multipleTable.length; i++) {
          this.updateIds.push({
            floor: this.floor,
            gid: this.multipleTable[i].gameid,
            target_version: this.multipleTable[i].target_version,
            chennel_category: this.multipleTable[i].chanel_type
          })
        }
        let opt = {
          url: "/api/apk/game_update/",
          type: "put",
          data: {
            args: this.updateIds,
          }
        }
        if (this.updateIds.length !== 0) {
          this.my_disable = ""
          const res = await getFetch(this, opt);
          if (res.code === 0) {
            this.my_disable = false
            alert("正在后台更新")
            this.getData()
          } else if (res.code === 6001) {
            this.my_disable = false
            alert(res.msg)
          } else {
            this.my_disable = false
            alert(res.msg)
          }
        } else {
          alert("请勾选游戏再进行更新")
        }
      },
      //进度条
      handleProgress(event, file, fileList) {
        // console.log("122", event)
        // console.log(file.name)
        // console.log(fileList)

      },
      handleAvatarSuccess() {
        this.resoucreList = [];
        this.dialogFile = "";
        this.dialogResourceVisible = false;
        //清除属性
        swal({
          title: '上传成功!',
          type: 'success',
          confirmButtonClass: 'btn btn-success btn-fill',
          buttonsStyling: false
        })
        this.getData();
      },
      checkfile(file, filelist) {
        for (let i = 0; i < filelist.length; i++) {
          if (filelist[i].name === file.name) {
            filelist.splice(i, 1)
          }
        }
      },
      //限制两个相同的文件
      // checksanmefile(filelsit, arg) {
      //     let temp = 0
      //     if (filelsit.length >= 2) {
      //         for (let i = 0; i < filelsit.length; i++) {
      //             if (filelsit[i].name.endsWith(arg)) {
      //                 temp += 1
      //             }
      //         }
      //         if (temp >= 2) {
      //             filelsit.splice(temp, 1)
      //             return filelsit
      //         }
      //     }
      // },
      apkhandleChange(file, fileList) {
        if (file.name.endsWith(".apk")) {
          this.dialogFile = file.raw;
        } else {
          alert("文件格式错误")
          this.checkfile(file, fileList)
        }
      },
      resourceChange(file, fileList) {
        if (file.name.endsWith(".apk")) {
          this.dialogFile = file.raw;
        } else {
          alert("文件格式错误")
          this.checkfile(file, fileList)
        }
      },
      getMyToken() {
        this.getToken.token = Cookie().get("token")
      },
      async submitUpload() {
        let _data = {
          floor: this.floor,
          reload: 1,
          gid: this.dialogData.gameid,
          targetSdkVersion: this.dialogData.target_version,
          channel_type: this.dialogData.chanel_type
        }
        this.postData = _data;
        //console.log(this.postData, '上传')
        setTimeout(() => {
          this.$refs.upload.submit()
        }, 1000);
      },

      cractResource(index, row) {
        this.dialogData = row;
        this.dialogResourceVisible = true
        this.getMyToken()
      },
      cractApk() {
        this.dialogapkVisible = true
        this.getMyToken()
      },

      changeTotal(length) {
        this.pagination.total = length
      },
      async getData(page, size) {
        page = this.pagination.currentPage
        size = this.pagination.perPage
        // name = this
        // type = this
        // gid = this
        let req_data = {}
        req_data['size'] = size
        req_data['page'] = page
        if (this.searchQuery !== '') {
          if (this.currentsearchType === this.searchType[0]) {
            req_data['type'] = 1
            req_data['gid'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[1]) {
            req_data['type'] = 2
            req_data['name'] = this.searchQuery
          } else {
            console.log('预留')
          }

        }

        let opt = {
          url: '/api/apkup/sypt_upload/',
          type: 'GET',
          data: req_data,
          //  如果需要接入第三方的接口，需要添加此参数
          // host:window.Config.homeHost
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          // console.log(res.data.uploadpackages.results)
          let temp = res.data.uploadpackages.results
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].floor == "sypt") {
              temp[i].floor = "第一事业部"
            } else if (temp[i].floor == "yypt") {
              temp[i].floor = "第二事业部"
            } else if (temp[i].floor == "jssy") {
              temp[i].floor = "第四事业部"
            }
            if (temp[i].package_path == '-1') {
              temp[i].package_path = '正在后台处理中'
            }
          }
          this.tableData = temp
          this.changeTotal(res.data.uploadpackages.total_count)
          this.total_count = res.data.uploadpackages.total_count
          this.pagination.page_count = res.data.uploadpackages.total_page
          this.searchQuery = ''
        } else if (this.searchQuery) {
          alert("搜索记录为空,请检查搜索条件")
          this.searchQuery = ''
        }
      },

    },
    mounted() {
      this.getData();
    }
  }
</script>

